import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DestroyAbleComponent } from '../destroyable/destroyable.component';

@Component({
  selector: 'un-pagniation',
  templateUrl: './pagniation.component.html',
  styleUrls: ['./pagniation.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PagniationComponent
  extends DestroyAbleComponent
  implements OnInit
{
  @Input() pageIndex?: number | null;
  @Input() pageSize = 12;
  @Input() total?: number | null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ch: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.pageSize = this.route.snapshot.queryParams['limit'] || this.pageSize;
    this.ch.detectChanges();
  }
  pageSizeChange(size: number) {
    this.pageSize = size;
    this.updateUrl();
    this.ch.detectChanges();
  }

  pageIndexChange(page: number) {
    this.pageIndex = page;
    this.updateUrl();
  }

  private updateUrl() {
    this.router.navigate([], {
      queryParamsHandling: 'merge',
      preserveFragment: true,
      queryParams: {
        page: this.pageIndex,
        limit: this.pageSize,
      },
    });
  }
}
